<template>
  <div class="booking-choose-customer">
    <div class="field-title">请选择参与活动的客人</div>
    <div v-for="item in customerList" :key="item.bookingId">
      <p class="customer-info">
        <span>船票订单号：{{item.bookingId}}</span>
        <span>房间号：{{item.stateroomNumber}}</span>
      </p>
      <div class="customer-list">
        <ul>
          <li v-for="customer in item.bookingGuests" :key="customer.id" :class="['customer-item', {active: customerChoosed.indexOf(customer.id) >= 0, disabled: !customer.canSelect}]" @click="customerChange(customer)">
            <div class="name-box">
              <div class="check-box"></div>
              <p class="name el">{{customer.pinYinLastName}} {{customer.pinYinFirstName}}</p>
            </div>
            <p class="info">出生时间：{{dayjs(customer.dateOfBirth).format('YYYY-MM-DD')}}</p>
          </li>
        </ul>
      </div>
    </div>
    <a v-if="customerList.length < 8" v-show="!addShow" href="javascript:;" class="btn-add" @click="addShow = true">新增舱房<van-icon class="icon" name="plus" /></a>
    <div class="add-form" v-show="addShow">
      <div class="box-title">
        <span>新增舱房</span>
        <img class="icon" src="../../assets/icons/icon_reduce.png" alt="" @click="addShow = false" />
      </div>
      <div class="form-content">
        <div class="form-item" @click="screenTypeShow = true">
          <span>{{screenTypes[screenType].name}}</span>
          <van-icon class="icon-arrow" name="arrow-down" />
        </div>
        <div class="form-item" v-if="!screenType">
          <input class="ipt" type="text" v-model="bookingId" placeholder="请填写船票订单号">
        </div>
        <template v-else>
          <div class="form-item" @click="birthdayPickerShow = true">
            <input class="ipt" type="text" v-model="dateOfBirth" placeholder="出生日期">
            <van-icon class="icon-arrow" name="arrow-down" />
          </div>
          <div class="form-item">
            <input class="ipt" type="text" v-model="stateroomNumber" placeholder="请填写舱房号">
          </div>
        </template>
        <div class="form-item">
          <input class="ipt" type="text" v-model="lastName" placeholder="请填写订票人姓氏 例“ZHANG”" @input="lastNameInput">
        </div>
        <div class="form-item disabled">所乘游轮：{{bindTicket.shipName}}</div>
        <div class="form-item disabled">出航日期：{{sailDate}}</div>
        <van-button class="form-item btn-submit" block :loading="submitting" loading-text="加载中..." @click="handleSubmit">确认添加</van-button>
      </div>
    </div>
    <!-- 查询类型 -->
    <custom-picker title="选择查询方式" :columns="screenTypes" :visible.sync="screenTypeShow" @change="screenType = arguments[0]" />
    <!-- 生日 -->
    <base-picker type="date" :visible.sync="birthdayPickerShow" :value.sync="dateOfBirth" :min-date="minDate" />
  </div>
</template>

<script>
import BasePicker from '@/components/BasePicker'
import CustomPicker from '@/components/CustomPicker'
import api from '@/api'
import {hideLoading, showAlert, showLoading, showToast} from '@/utils/tools'
import dayjs from 'dayjs'
import pick from 'lodash/pick'
import { mapState } from 'vuex'

const screenTypes = [
  {
    name: '订单号',
    value: 0
  }, {
    name: '舱房号',
    value: 1
  }
]
export default {
  name: 'BookingChooseCustomer',

  components: {
    BasePicker,
    CustomPicker
  },

  props: {
    goodsInfo: Object,
    isFullCabinBooking: {
      type: Boolean,
      default: false
    },
    canBookingGuests: Array
  },

  data () {
    return {
      dayjs,
      screenTypes,
      addShow: false,
      customerList: [],
      customerChoosed: [],
      screenTypeShow: false,
      screenType: 0,
      birthdayPickerShow: false,
      minDate: dayjs().subtract(100, 'year').toDate(),
      dateOfBirth: '',
      bookingId: '',
      stateroomNumber: '',
      lastName: '',
      submitting: false,
      addedBook: 0
    }
  },

  computed: {
    ...mapState(['bindTicket']),
    productId () {
      return this.goodsInfo.id
    },
    sailDate () {
      return dayjs(this.bindTicket.sailDate).format('YYYY-MM-DD')
    },
    isRespecting () {
      // return this.goodsInfo.name.indexOf('皇家尊享服务') >= 0
      return this.goodsInfo.name.indexOf('皇家尊享服务') >= 0
    }
  },
  watch: {
    goodsInfo (val) {
      this.initData(val)
    },
    isFullCabinBooking () {
      this.initData(this.goodsInfo)
    }
  },
  mounted () {
  },
  methods: {
    initData(val) {
      this.customerList = [];
      this.customerChoosed = [];
      const { initBookingGuests, initBookingGuestsChoosed } = val
      if (initBookingGuests && initBookingGuestsChoosed) {
        this.customerList = initBookingGuests
        this.customerChoosed = initBookingGuestsChoosed
        if (this.isFullCabinBooking) {
          this.customerList && this.customerList.forEach((row) => {
            row.bookingGuests = row.bookingGuests.map(x => ({...x, canSelect: this.customerChoosed.includes(x.id)}))
          })
        }
      } else {
        const { bookingGuests, ...others } = this.$store.state.bindTicket
        this.customerList.push({
          ...others,
          bookingGuests: bookingGuests.map(x => ({ ...x, canSelect: true }))
        })
        if (this.isFullCabinBooking) {
          this.customerChoosed = this.canBookingGuests.map(x => x.id)
          this.customerList && this.customerList.forEach((row)=> {
            row.bookingGuests = row.bookingGuests.map(x => ({ ...x, canSelect: this.customerChoosed.includes(x.id) }))
          })
          this.$emit('customerChange', this.customerChoosed.length)
        }
      }
    },
    async handleSubmit () {
      if (this.submitting) return
      if (!this.screenType) {
        if (!this.bookingId.length) return showToast('请填写船票订单号')
        let selectBookingNum = 0;
        this.customerList && this.customerList.forEach(item => {
          if(item.bookingId === this.bookingId) {
            selectBookingNum++;
          }
        })
        if(selectBookingNum>0) return showToast('该船票订单已添加')
      } else {
        if (!this.dateOfBirth) return showToast('请选择出生日期')
        if (!this.stateroomNumber.length) return showToast('请填写舱房号')
        if (this.stateroomNumber === this.bindTicket.stateroomNumber) return showToast('该船票订单已添加')
      }
      if (!this.lastName.length) return showToast('请填写订票人姓氏')
      this.submitting = true
      const { errCode, errMsg, data } = await api.getCanSelectGuestsByProduct({
        ...pick(this.$data, ['bookingId', 'stateroomNumber', 'dateOfBirth', 'lastName']),
        shipCode: this.bindTicket.shipCode,
        sailDate: this.sailDate,
        productId: this.productId
      })
      this.submitting = false
      if (errCode === 0) {
        const { bookingGuests, ...others } = data
        const bookingGuestsFormat = bookingGuests.guestPersons.map(x => ({ ...x, pinYinFirstName: x.pyFirstName, pinYinLastName: x.pyLastName, dateOfBirth: x.birthDay }))
        this.customerList.push({
          ...others,
          bookingGuests: bookingGuestsFormat
        })
        await this.getCanBookingGuests(this.productId, this.sailDate, this.bookingId);
        this.$emit('customerSubmit', this.bookingId)
        this.addShow = false
        this.dateOfBirth = ''
        this.bookingId = ''
        this.stateroomNumber = ''
        this.lastName = ''
        this.addedBook ++
      } else {
        showAlert(errMsg || '添加失败，请稍后重试')
      }
    },
    lastNameInput () {
      if (/^[a-zA-Z]+$/.test(this.lastName.trim())) this.lastName = this.lastName.toUpperCase()
    },
    customerChange ({ id, canSelect }) {
      if (!canSelect) return
      if (this.isFullCabinBooking) return showAlert('该产品仅限全房客人预订')
      const currentIndex = this.customerChoosed.indexOf(id)
      if (currentIndex >= 0) {
        this.customerChoosed.splice(currentIndex, 1)
      } else {
        this.customerChoosed.push(id)
      }
      this.$emit('customerChange', this.customerChoosed.length)
    },
    async getCanBookingGuests (productId, sailDate, bookingId) {
      console.log(productId, sailDate, bookingId)
      showLoading()
      const { errCode, errMsg, data } = await api.getCanBookingGuests({
        productId: productId,
        sailDate: sailDate,
        bookingId: bookingId
      })
      hideLoading()
      if (errCode === 0) {
        if (data.isFullCabinBooking) {
          let canBookingGuests = data.bookingGuests.map(x => x.id);
          this.customerChoosed = this.customerChoosed.concat(canBookingGuests)
          this.$emit('customerChange', this.customerChoosed.length)
        }
      } else {
        showAlert(errMsg || '页面数据获取失败，请稍后重试')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.booking-choose-customer {
  padding-bottom: 24px;
}
.customer-info {
  font-size: 18px;
  color: #999;
  line-height: 36px;
  span {
    margin-right: 12px;
  }
}
.customer-list {
  padding: 20px 0;
  .customer-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 46px;
    margin-bottom: 10px;
    padding: 0 22px 0 11px;
    border-radius: 6px;
    border: 1Px solid #eaeaea;
    font-size: 18px;
    color: #999;
    &.active {
      background-color: @second-color;
      .name-box .check-box {
        background: #e1af00 url('../../assets/icons/icon_check.png') center center no-repeat;
        background-size: 16px auto;
      }
    }
    &.disabled{
      opacity: .6;
    }
    .name-box {
      display: flex;
      align-items: center;
      font-size: 24px;
      color: #333;
      .check-box {
        flex: none;
        width: 28px;
        height: 28px;
        margin-right: 22px;
        border-radius: 5px;
        background-color: #e5e5e5;
      }
    }
  }
}
.btn-add {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 200px;
  height: 48px;
  box-sizing: border-box;
  padding: 0 12px 0 30px;
  border-radius: 6px;
  font-size: 24px;
  color: #1174b8;
  background-color: #e8f4fe;
  .icon {
    font-size: 24px;
    color: #1174b8;
  }
}
.add-form {
  border-radius: 6px;
  overflow: hidden;
  background-color: #e8ecef;
  .box-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 52px;
    padding: 0 30px;
    font-size: 24px;
    color: #fff;
    background-color: #1174b8;
    .icon {
      width: 16px;
    }
  }
  .form-content {
    padding: 20px 28px;
    .form-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 52px;
      margin-bottom: 15px;
      padding: 0 26px 0 30px;
      border-radius: 6px;
      background-color: #fff;
      font-size: 24px;
      color: #242e65;
      &.disabled {
        color: #333;
        background-color: #d7dde1;
      }
      .icon-arrow {
        font-size: 24px;
      }
      .ipt {
        flex: 1;
        height: 28px;
        padding-left: 0;
        border: none;
        outline: none;
      }
    }
    .btn-submit {
      justify-content: center;
      color: #333;
      line-height: 32px;
      background-color: @second-color;
    }
  }
}
</style>
